import React, { Component } from 'react';
import { Backdrop, CircularProgress } from "@mui/material";
import { useTheme, ThemeProvider, createTheme } from '@mui/material/styles';

export function LoadSpinner(props) {
  const theme = useTheme();
  
    return (
        <>
        {props.active && <Backdrop open={props.active} sx={{ backgroundColor: (theme.palette.mode == 'dark') ? 'rgba(0,0,0,.75)' : 'rgba(255,255,255,.75)' }}>
          <CircularProgress />
        </Backdrop>}
        </>
    );
  
}


